import { atom } from "recoil"

const unreadState = atom({
  key: "unread",
  default: 0,
})

export default unreadState
